import * as XLSX from "xlsx"
import * as dayjs from "dayjs";
import { Translation, TranslationProps } from "react-i18next";
import i18n from 'i18next';
import ApiService from "../services/ApiService";
import FileService from "../services/FileService";
import axios from "axios";
import { API } from "../config";

//한영전환
export function fni18n(value) {
    return <Translation>{(t, { i18n }) => t(value)}</Translation>;
}

//API Service 호출
export function getAPI(url, param) {
    // console.log("getAPI-URL : " + url);
    // console.log("getAPI-PARAM : " + JSON.stringify(param));
    //return axios.get(url, {params : param});
    return ApiService({ url: url, method: "get", params: param });
}
export function postAPI(url, param) {
    const params = new URLSearchParams(param);
    // console.log("postAPI-URL : " + url);
    // console.log("postAPI-PARAM : " + JSON.stringify(param));
    //return axios.post(url, params);
    return ApiService({ url: url, method: "post", params: param });
}
export function putAPI(url, param) {
    const params = new URLSearchParams(param);
    // console.log("putAPI-URL : " + url);
    // console.log("putAPI-PARAM : " + JSON.stringify(param));
    //return axios.put(url, params);    
    return ApiService({ url: url, method: "put", params: param });
}
export function deleteAPI(url, param) {
    // console.log("deleteAPI-URL : " + url);
    // console.log("deleteAPI-PARAM : " + JSON.stringify(param));
    //return axios.delete(url, {params : param});
    return ApiService({ url: url, method: "delete", params: param });
}

export function postFILE(url, fd) {
    // console.log("postFILE-URL : " + url);
    // console.log("postFILE-PARAM : " + fd);

    return FileService.files(url, fd);
}

//EXCEL
function fitToColumn(arr) {
    return arr[0].map((a, i) => ({
        wch: Math.max(
            ...arr.map((a2) => (a2[i] ? a2[i].toString().length * 1.2 > 90 ? 90 : a2[i].toString().length * 1.2 : 0))
        ),
    }));
}

export const fnExcel = (columns, rows, e, total) => {
    if (!rows.length > 0) {
        return;
    }

    //240820 이재형 수정 :: hide된 컬럼까지 엑셀다운받게 변경
    const cols = columns.map((col) => i18n.t(col.headerName));
    const keys = columns.map((col) => col.field);
    const colSpans = columns.filter(col => col.colSpan).map(col => col.colSpan);
    const copyRow = rows;

    colSpans.map(col => {
        col.filter(child => keys.includes(child.parentField))
            .map(child => {
                const index = keys.indexOf(child.parentField);
                const parentHeaderName = cols[index];
                keys.splice(index, 0, child.field);
                cols.splice(index, 0, parentHeaderName + " / " + i18n.t(child.headerName));
            })
    });

    colSpans.map(col => {
        col.filter(child => keys.includes(child.parentField))
            .map(child => {
                const index = keys.indexOf(child.parentField);
                if (index > 0) {
                    keys.splice(index, 1)
                    cols.splice(index, 1)
                }
            })
    });
    const page = window.location.pathname.split("/")[2];
    const excelName = page + "_" + dayjs(new Date()).format("YYYYMMDDhhmmss") + ".xlsx";//파일명
    const sheeName = "sheet1";//시트명
    const excelData = [];
    excelData.push(cols);
    copyRow.map((row) => {
        const resultRow = [];
        //Object.keys(row).filter(key => !keys.includes(key)).map(key => delete row[key]);
        keys.map(key => resultRow.push(i18n.t(row[key])));
        excelData.push(resultRow);
    });

    let merge = null;
    if (typeof total != "undefined") {
        merge = [{ s: { r: excelData.length, c: 0 }, e: { r: excelData.length, c: 2 } }];
        total.map((m) => {
            const totalRow = [];
            //Object.keys(m).filter(key => !keys.includes(key)).map(key => delete m[key]);
            keys.map(key => totalRow.push(i18n.t(m[key])));
            totalRow[0] = i18n.t("전체");
            excelData.push(totalRow);
        });
    }

    const datas = XLSX.utils.aoa_to_sheet(excelData);
    datas["!cols"] = fitToColumn(excelData);
    if (merge !== null) datas['!merges'] = merge;
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, datas, sheeName);
    XLSX.writeFile(workbook, excelName);
}

//공통 팝업 호출
export function fnCallPopUp(url, width, height, obj) {
    //width = 팝업의 가로 길이
    //height= 팝업의 세로 길이

    // 팝업을 부모 브라우저의 정 중앙에 위치시킨다.
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    var param = "";
    if (obj) {
        for (var obj_element in obj) {
            var obj_value = obj[obj_element];
            if (param != "") {
                param = param + "&"
            } else {
                param = param + "?"
            }
            param = param + obj_element + "=" + obj_value
        }
    }
    param = url + param;

    const popup = window.open(
        param,
        "로그인 중...",
        `width=${width},height=${height},left=${left},top=${top}` + ", location=no"
    );
}

export function bytesToSize(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if (bytes === 0) return 'n/a'
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
    if (i === 0) return `${bytes} ${sizes[i]})`
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
}

const asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index += 1) {
        await callback(array[index], index, array)
    }
}
export default asyncForEach;

/**
 * 로그인 유저 이름
 */
export function GetLoggedInUserName(userId, storeCd) {
    return ApiService({ url: API.COMMON.USER_NAME, method: "get", params: { userId: userId, branch:storeCd } });
}
